import api from './api';

export interface JailedUser {
  id: number;
  username: string;
  rank: number;
  rankName: string;
  reward: number;
  crime: string;
  timeRemaining: number; // in seconds
  jailedAt: string;
}

export interface BustResult {
  success: boolean;
  message: string;
  reward?: number;
}

export const jailService = {
  // Get all users currently in jail
  getJailedUsers: async (): Promise<JailedUser[]> => {
    const response = await api.get('/game/jailed-users');
    return response.data;
  },

  // Bust a user out of jail
  bustUser: async (userId: number, reward: number): Promise<BustResult> => {
    const response = await api.post('/game/bust-user', {
      userId,
      reward
    });
    return response.data;
  },

  // Set bust reward for a jailed user
  setBustReward: async (userId: number, reward: number): Promise<void> => {
    await api.post('/game/set-bust-reward', {
      userId,
      reward
    });
  },

  // Calculate bust success rate based on ranks
  calculateBustChance: (jailedUserRank: number, busterRank: number): number => {
    const rankDifference = busterRank - jailedUserRank;
    
    // Base 50% chance for same rank
    let chance = 50;
    
    // For every rank higher, +5% (max 100%)
    if (rankDifference > 0) {
      chance += rankDifference * 5;
      chance = Math.min(chance, 100);
    }
    
    // For every rank lower, -5% (min 0%)
    if (rankDifference < 0) {
      chance += rankDifference * 5;
      chance = Math.max(chance, 0);
    }
    
    return chance;
  }
};
